import { isArray, isObject, reduce } from 'lodash'

export function removeTypename(obj) {
  if (isArray(obj)) {
    return obj.map(removeTypename)
  }

  if (isObject(obj) && obj !== null) {
    return reduce(
      obj,
      (acc, value, key) => {
        if (key !== '__typename') {
          acc[key] = removeTypename(value)
        }
        return acc
      },
      {},
    )
  }

  return obj
}

export default removeTypename
